import {ensureHierarchy, mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '../../visual-feature.js';

import {racingConfig} from './racing.factory';

import SCHEMA from './racing.schema.yaml';

class RacingFeature extends AbstractVisualFeature {
    get name() {
        return 'Racing';
    }

    getVisualConfig() {
        return racingConfig();
    }

    get configSchema() {
        return SCHEMA;
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const configurations = ensureHierarchy(mojitoConfig, 'services.configurations');

        mergeTo(configurations, {
            RaceExplanationPane: {
                items: this.config.legends,
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

export const Racing = FEATURES.racing ? new RacingFeature(allVisuals) : null;
